import React, { useState } from "react";

import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";

function Ownership() {

  const [ownerships, setOwnerships] = useState([]);

  const [form, setForm] = useState({
    customer: "",
    plot: "",
    amount: "",
    status: "Active"
  });

  const handleChange = (e) => {

    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {

    e.preventDefault();

    setOwnerships([
      ...ownerships,
      form
    ]);

    setForm({
      customer: "",
      plot: "",
      amount: "",
      status: "Active"
    });
  };

  return (

    <div>

      <Navbar />

      <Sidebar />

      <div className="main-content">

        <h1>Ownership</h1>

        <form onSubmit={handleSubmit}>

          <input
            type="text"
            name="customer"
            placeholder="Customer Name"
            value={form.customer}
            onChange={handleChange}
          />

          <input
            type="text"
            name="plot"
            placeholder="Plot Number"
            value={form.plot}
            onChange={handleChange}
          />

          <input
            type="number"
            name="amount"
            placeholder="Sale Amount"
            value={form.amount}
            onChange={handleChange}
          />

          <select
            name="status"
            value={form.status}
            onChange={handleChange}
          >
            <option>Active</option>
            <option>Transferred</option>
          </select>

          <button type="submit">
            Add Ownership
          </button>

        </form>

        <br />

        <div className="dashboard-grid">

          {
            ownerships.map((item, index) => (

              <div className="card" key={index}>

                <h3>{item.customer}</h3>

                <p>{item.plot}</p>

                <p>₹{item.amount}</p>

                <p>{item.status}</p>

              </div>
            ))
          }

        </div>

      </div>

    </div>
  );
}

export default Ownership;